import React, { useEffect, useState } from 'react';

// import { HashRouter as Router, Routes,  } from 'react-router-dom';
import AOS from 'aos';
import 'aos/dist/aos.css';

import '../App.css';
import Header from './Header.js'
import Hero from './hero.js'
import Features from './Features.js'
import Pricing from './Pricing.js'
import Faq from './Faq.js'
import About from '../pages/main/About.js'
import Contact from '../pages/main/Contact.js'
import Footer from './Footer.js'
import Signup from './Signup.js'
import Signin from './Signin.js'



function Main() {
    const [displaySignIn, setDisplaySignIn] = useState(false);
    const [displaySignUp, setDisplaySignUp] = useState(false);

    const toggleSignIn = ()=>{
        setDisplaySignIn(!displaySignIn);
    }
    const toggleSignUp = ()=>{
        setDisplaySignUp(!displaySignUp);
    }

    useEffect(() => {
        AOS.init({
            duration: 1200, // Animation duration
            easing: 'ease-in-out', // Animation easing
            offset: 100, // Offset from the trigger point
            once: true, // Whether animation should happen only once
            delay: 100, // Delay before animation starts

        });
        AOS.refresh();
    }, []);

    return ( 
        <div className = " text-center bg-light1 dark:bg-dark1 text-dark1 dark:text-light relative overflow-hidden" >
            
            <Header />
            <Hero onSignInClick={toggleSignIn} onSignUpClick={toggleSignUp} />
            < Features />
            <About/>
            <Pricing />
            <Faq />
            <Contact/>
            <div
                className={`fixed inset-0 flex items-center justify-center transition-opacity duration-500 ${
                    displaySignIn ? 'opacity-100 visible z-50' : 'opacity-0 invisible'
                } bg-black bg-opacity-50`}
                >
                {displaySignIn && <Signin onClose={toggleSignIn} />}
            </div>
            <div
                className={`fixed inset-0 flex items-center justify-center transition-opacity duration-500 ${
                    displaySignUp ? 'opacity-100 visible z-50' : 'opacity-0 invisible'
                } bg-black bg-opacity-50`}
                >
                {displaySignUp && <Signup onClose={toggleSignUp} />}
            </div>
            {/* <WalletBalance/>
            <WalletBalances/>
            <Addpost />*/}
            <Footer/> 
        </div>
    );
}

export default Main;